import { extend } from 'vee-validate';
import { required, email, min } from 'vee-validate/dist/rules.umd.js';
import custom from './custom';

extend('required', required);
extend('email', email);
extend('min', min);
extend('fullname', custom.fullname);
extend('phone', custom.phone);
extend('cep', custom.cep);
extend('date', custom.date);
extend('alpha_num_spaces', custom.alpha_num_spaces);
